import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import { useContext } from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { useTranslation } from 'react-i18next'
import platform from 'utils/platform'
import OrderContext from '../_context'

export default function AddressRow() {
	/** @type Order */
	const order = useContext(OrderContext)
	const { t } = useTranslation()

	if (!order.is_delivery) {
		return null
	}

	const oneLineAddress = order.full_delivery_address.replace(/\n/g, ' - ')
	const addressLines = order.full_delivery_address.split('\n')
	const firstLine = addressLines.shift()

	//may need the target=_system + inappbrowser plugin: https://stackoverflow.com/a/42397304/102960
	const addressUrl = platform.isAndroid()?
			`geo:?q=${oneLineAddress}` : //allows Android users to select their preferred Map application
			`https://maps.apple.com/maps?q=${oneLineAddress}?t=1` //goes to GMaps when there's no Apple Maps (old iOS, non-Mac desktops)

	return <Row>
		<Col xs="auto" className="secondary pr-1 d-flex align-items-center">
			<Icon icon="map-marker-alt" fixedWidth/>
			<span className="text-bold-reset">
				{firstLine}
				{!!addressLines.length && <small className="d-block">{addressLines.join(', ')}</small>}
			</span>
		</Col>
		<Col className="d-print-none">
			<Btn swap size="sm" variant="light" icon="map-marked-alt" target="_blank" href={addressUrl}>{t('Map')}</Btn>
		</Col>
	</Row>
}
